// Mapping between service IDs and their routes
// This will be used across the application to ensure consistency
export const getServiceRoute = (serviceId: string): string => {
  const serviceRoutes: Record<string, string> = {
    wdh: "/services/website-development/",
    // Individual service pages that are already created
    sds: "/services/software-development/",
    sis: "/services/system-integration/",

    // Other services (using the IDs from ServicesSection)
    web: "/services/web-development/",
    cyber: "/services/cyber-security/",
    consult: "/services/it-consultation/",
    cloud: "/services/cloud-services/",
    ai: "/services/ai-solutions/",
    data: "/services/data-analysis/",

    // Services from the original list using the IDs from ServiceDetails
    dtc: "/services/digital-transformation/",
    cadi: "/services/cloud-architecture/",
    er: "/services/enterprise-resilience/",
    hsp: "/services/hardware-software/",
    pm: "/services/product-management/",
    as: "/services/ai-solutions/",
    sm: "/services/smart-manufacturing/",
    te: "/services/training-education/",
  };

  // Return the route if it exists, otherwise return a fallback
  return serviceRoutes[serviceId] || "/service/";
};
